import {StyledDayButton} from '@/components/commons/calendar/day-button/style'
import dayjs from 'dayjs'
import {DayButtonProps} from 'react-day-picker'

export const DayButton = (props: DayButtonProps) => {
    return (
        <StyledDayButton {...props} disabled={props.modifiers.outside}>
            {parseInt(dayjs(props.day.date).format('DD'))}
        </StyledDayButton>
    )
}
